import classNames from "classnames"
import { WearableCardProps } from "."
import Badge from "@/components/shared/Badge"
import { Icon, IconColor } from "@/components/shared/Icon"

interface WearableCardSmallProps extends WearableCardProps {
   hasAction?: boolean
   isClickable?: boolean
}

const WearableCardSmall = ({
   hasAction = false,
   lowBattery,
   isClickable,
   isCollapsed,
   onClick,
}: WearableCardSmallProps) => {
   return (
      <Badge invisible={!hasAction}>
         <div
            className={classNames("wearable-card", "wearable-card--small", {
               "wearable-card--clickable": isClickable,
               "wearable-card--collapsed": isCollapsed,
            })}
            onClick={onClick}
         >
            <Icon
               className={classNames({
                  "wearable-card__battery-icon": lowBattery,
               })}
               size="16"
               color={IconColor.WHITE}
               name={lowBattery ? "batteryEmpty" : "smartwatch"}
            />
         </div>
      </Badge>
   )
}

export default WearableCardSmall
